import { jsx } from 'react/jsx-runtime';
import { twMerge } from '@belong/common/twMerge';
import { ButtonBase } from '../../../ButtonBase/ButtonBase.js';
import { Text } from '../../../Text/Text.js';
import css from './button-selector-item.module.css.js';

const heightMap = {
  'extra-small': css.heightExtraSmall,
  small: css.heightSmall,
  large: css.heightLarge,
  'extra-large': css.extraLarge,
  fluid: 'h-auto'
};
const widthMap = {
  small: css.widthSmall,
  fluid: 'w-full'
};
const ButtonSelectorItem = ({
  children,
  disabled = false,
  error,
  height = 'small',
  onClick,
  selected = false,
  selectedClassName,
  width = 'fluid',
  className
}) => {
  const isSelectedColor = selected ? 'text-white' : 'text-navy';
  return jsx(ButtonBase, {
    className: twMerge(css.heightMobile, heightMap[height], widthMap[width], 'rounded flex items-center justify-center shadow', 'hover:transition-colors duration-hover border-transparent border-3 border-solid hover:border-navy disabled:shadow-none disabled:bg-light-gray disabled:pointer-events-none disabled:border disabled:border-gray disabled:border-solid', selected && 'bg-navy', error && 'border-red hover:border-dark-red', className, selected && selectedClassName),
    disabled: disabled,
    onClick: onClick,
    type: "button",
    children: typeof children === 'string' ? jsx(Text, {
      className: disabled ? 'text-gray' : isSelectedColor,
      fontWeight: selected ? 'semibold' : 'regular',
      children: children
    }) : children
  });
};

export { ButtonSelectorItem };
